import React from "react";
import { ClipboardList, Settings, Rocket, HeartHandshake } from "lucide-react";

const steps = [
  {
    icon: <ClipboardList size={22} />,
    num: "01",
    title: "Appel gratuit de 30 min",
    desc: "On discute de votre entreprise et on identifie ce que l'IA peut faire pour vous. Sans engagement.",
  },
  {
    icon: <Settings size={22} />,
    num: "02",
    title: "On configure tout",
    desc: "On prépare votre serveur IA et vos outils selon vos besoins. Vous n'avez rien à faire.",
  },
  {
    icon: <Rocket size={22} />,
    num: "03",
    title: "Installation en 48h",
    desc: "Notre équipe se déplace chez vous, installe tout et forme vos employés. Opérationnel le même jour.",
  },
  {
    icon: <HeartHandshake size={22} />,
    num: "04",
    title: "On reste avec vous",
    desc: "Support local, mises à jour et suivi continu. On est là sur le long terme.",
  },
];

export default function HowItWorks() {
  return (
    <section id="technologie" style={{ background: "#f5f5f7" }} className="section-pad">
      <div className="section-wrap">

        <div style={{ textAlign: "center", marginBottom: "56px" }}>
          <span className="eyebrow">Comment ça marche</span>
          <h2 className="h-section">
            Simple comme
            <br />
            <span className="text-gradient">1 — 2 — 3 — 4.</span>
          </h2>
          <p className="body-lg" style={{ maxWidth: "420px", margin: "16px auto 0" }}>
            Pas besoin d'équipe TI. On s'occupe de tout.
          </p>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))", gap: "16px" }}>
          {steps.map((s, i) => (
            <div key={i} className="card-apple" style={{ padding: "28px", display: "flex", flexDirection: "column", gap: "14px" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div style={{
                  width: 48, height: 48, borderRadius: 14,
                  background: "linear-gradient(145deg, #0071e3, #0a84ff)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  color: "#fff", boxShadow: "0 6px 20px rgba(0,113,227,0.25)",
                }}>
                  {s.icon}
                </div>
                <span style={{ fontFamily: "'Plus Jakarta Sans'", fontSize: "2rem", fontWeight: 800, color: "rgba(0,0,0,0.06)", letterSpacing: "-0.04em" }}>
                  {s.num}
                </span>
              </div>
              <h3 style={{ fontFamily: "'Plus Jakarta Sans'", fontSize: "1rem", fontWeight: 700, color: "#1d1d1f", letterSpacing: "-0.02em", lineHeight: 1.3 }}>
                {s.title}
              </h3>
              <p style={{ fontSize: "0.875rem", color: "#6e6e73", lineHeight: 1.6 }}>{s.desc}</p>
            </div>
          ))}
        </div>

        <div style={{ textAlign: "center", marginTop: "48px" }}>
          <a href="#contact" className="btn-primary">
            Réserver mon appel gratuit
          </a>
        </div>
      </div>
    </section>
  );
}
